
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    A: "A",
    RJ: "RJ",
    D: "D",
    RZ: "RZ"
}
